import { RouterProvider } from "react-router";
import { router } from "./routes";
import { AuthProvider } from "../providers/AuthProvider";
import { ThemeProvider } from "../context/ThemeProvider";
import { Toaster } from "./components/ui/sonner";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./queryClient";

export default function App() {
  return (
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <RouterProvider router={router} />
          <Toaster />
        </AuthProvider>
      </QueryClientProvider>
    </ThemeProvider>
  );
}
